export class BlockDeleteBin {
    public id:number;
	public rol:string;
	public comentarioOpe:string;
	public procedencia:string;
	public bin:string;
	public idGrupo:number;
	public binesList:string;
	constructor(){
		this.id = null;
		this.rol = localStorage.getItem('currentRol');
		this.comentarioOpe = null;
		this.procedencia = null;
		this.bin = null;
		this.idGrupo = null;
	}
}